(ns nosco.icons2
  (:require
   [clojure.string :as string]
   [hx.react :as hx :refer [defnc]]
   [nosco.placeholders :as placeholders]
   [nosco.react :as nosco-react]
   [nosco.ui.html]
   [shadow.resource :as rc])
  (:require-macros [nosco.icons2]
                   [nosco.figma-utils]))

;; get the svg as a big string -- shadow.cljs makes sure to
;; refresh the build when the file changes to get hot reloading
(def raw-svg-source (rc/inline "icons2.svg"))

(def nosco-logo (rc/inline "public/main/img/nosco-logo.svg"))

(defnc NoscoLogo [{:keys [style class]}]
  [nosco.ui.html/UnsafeHTML {:style style
                             :class class
                             :html nosco-logo}])

;; load this element ONCE in the file, the huge svg is hidden
(defnc MainSVG []
  [nosco.ui.html/UnsafeHTML {:style {:display "none"}
                             :html raw-svg-source}])

(def xsmall-ids (nosco.icons2/inline-icon-ids :xsmall))
(def small-ids (nosco.icons2/inline-icon-ids :small))
(def large-ids (nosco.icons2/inline-icon-ids :large))

(defn stem [icon-str]
  (cond (string/starts-with? icon-str "12px-Xsmall") (subs icon-str (count "12px-Xsmall"))
        (string/starts-with? icon-str "16px-Small") (subs icon-str (count "16px-Small"))
        (string/starts-with? icon-str "24px-Large") (subs icon-str (count "24px-Large"))))

(defn ->xsmall [icon-str]
  (str "12px-Xsmall" (stem icon-str)))

(defn ->small [icon-str]
  (str "16px-Small" (stem icon-str)))

#_{:clojure-lsp/ignore [:clojure-lsp/unused-public-var]}
(defn ->large [icon-str]
  (str "24px-Large" (stem icon-str)))

;; We cannot use a "style" property because hx converts it to a js object
;; It seems like a bug in hx?
;; We will use the "icon-style" property instead until hx is fixed
(defnc Icon [{:keys [icon icon-style color] :as props}]
  (let [href (str "#" (string/trim (name icon)))
        style (cond
                (get xsmall-ids icon) {:width "12px"
                                       :height "12px"}
                (get small-ids icon) {:width "16px"
                                      :height "16px"}
                (get large-ids icon) {:width "24px"
                                      :height "24px"})
        style (if color (merge style {:fill color}) style)
        style (merge style icon-style)]
    [:svg
     (-> {:class "nosco-icon"
          :aria-label (name icon)
          :style style}
         (nosco-react/merge-props (dissoc props :icon :style :icon-style :color)))
     [:use {:href href :xlinkHref href}]]))

(defnc IconOnGrayCircle [{:keys [icon]}]
  [:div {:class "nosco-icons-icon-on-gray-circle"}
   [Icon {:icon icon}]])

(defnc LoadingIcon
  "An SVG icon that can be spinned without artifacts. You need to apply your own
   spinning animation and positioning on top. An explicit color is required."
  [{:keys [size color] :as props
    :or {size :small}}]
  (let [circles {:small {:cx 8 :cy 8 :r 6 :stroke color :stroke-width 1.85 :fill "transparent"}
                 :large {:cx 12 :cy 12 :r 8 :stroke color :stroke-width 2 :fill "transparent"}}]
    [:svg (-> {:class "nosco-icon"
               :aria-label "Loading"
               :style (cond-> {}
                        (= size :large) (merge {:width "24px" :height "24px"})
                        (= size :small) (merge {:width "16px" :height "16px"}))}
              (nosco-react/merge-props (dissoc props :color :size)))
     [:circle (assoc (get circles size) :stroke-dasharray "56.66% 100")]
     [:circle (assoc (get circles size) :opacity "0.4")]]))

(defnc PlaceholderImage [{:keys [variant id] :as props}]
  ;; NOTE keeping the variant argument if we ever want to
  ;; differentiate the placeholder images based on type
  ;; but for now we only have one variant that is responsive
  (case variant
    (:idea-list :idea-card :channel)
    [placeholders/Placeholder (nosco-react/merge-props
                               {:idx (placeholders/variant-idx id)}
                               (dissoc props :variant))]))

#_{:clojure-lsp/ignore [:clojure-lsp/unused-public-var]}
;; == DO NOT EDIT -- AUTOMATICALLY GENERATED ===================================
;; To update, run `bb update-icons`
(nosco.figma-utils/defmap _
  {AI-large "24px-LargeAI",
   AI-small "16px-SmallAI",
   AI-xsmall "12px-XsmallAI",
   Access-large "24px-LargeAccess",
   Access-small "16px-SmallAccess",
   Access-xsmall "12px-XsmallAccess",
   Active-large "24px-LargeActive",
   Active-small "16px-SmallActive",
   Active-xsmall "12px-XsmallActive",
   Activity-large "24px-LargeActivity",
   Activity-small "16px-SmallActivity",
   Activity-xsmall "12px-XsmallActivity",
   Add-large "24px-LargeAdd",
   Add-note-large "24px-LargeAdd-note",
   Add-note-small "16px-SmallAdd-note",
   Add-note-xsmall "12px-XsmallAdd-note",
   Add-small "16px-SmallAdd",
   Add-user-large "24px-LargeAdd-user",
   Add-user-small "16px-SmallAdd-user",
   Add-user-xsmall "12px-XsmallAdd-user",
   Add-xsmall "12px-XsmallAdd",
   Admin-large "24px-LargeAdmin",
   Admin-small "16px-SmallAdmin",
   Admin-xsmall "12px-XsmallAdmin",
   Alarm-large "24px-LargeAlarm",
   Alarm-small "16px-SmallAlarm",
   Alarm-xsmall "12px-XsmallAlarm",
   AlignCenter-large "24px-LargeAlignCenter",
   AlignCenter-small "16px-SmallAlignCenter",
   AlignCenter-xsmall "12px-XsmallAlignCenter",
   AlignLeft-large "24px-LargeAlignLeft",
   AlignLeft-small "16px-SmallAlignLeft",
   AlignLeft-xsmall "12px-XsmallAlignLeft",
   AlignRight-large "24px-LargeAlignRight",
   AlignRight-small "16px-SmallAlignRight",
   AlignRight-xsmall "12px-XsmallAlignRight",
   Anonymous-large "24px-LargeAnonymous",
   Anonymous-small "16px-SmallAnonymous",
   Anonymous-xsmall "12px-XsmallAnonymous",
   Apps-large "24px-LargeApps",
   Apps-small "16px-SmallApps",
   Apps-xsmall "12px-XsmallApps",
   Archive-large "24px-LargeArchive",
   Archive-small "16px-SmallArchive",
   Archive-xsmall "12px-XsmallArchive",
   Arrow-down-large "24px-LargeArrow-down",
   Arrow-down-small "16px-SmallArrow-down",
   Arrow-down-xsmall "12px-XsmallArrow-down",
   Arrow-left-large "24px-LargeArrow-left",
   Arrow-left-small "16px-SmallArrow-left",
   Arrow-left-xsmall "12px-XsmallArrow-left",
   Arrow-right-large "24px-LargeArrow-right",
   Arrow-right-small "16px-SmallArrow-right",
   Arrow-right-xsmall "12px-XsmallArrow-right",
   Arrow-up-large "24px-LargeArrow-up",
   Arrow-up-small "16px-SmallArrow-up",
   Arrow-up-xsmall "12px-XsmallArrow-up",
   Asterisk-large "24px-LargeAsterisk",
   Asterisk-small "16px-SmallAsterisk",
   Asterisk-xsmall "12px-XsmallAsterisk",
   At-sign-large "24px-LargeAt-sign",
   At-sign-small "16px-SmallAt-sign",
   At-sign-xsmall "12px-XsmallAt-sign",
   Attach-large "24px-LargeAttach",
   Attach-small "16px-SmallAttach",
   Attach-xsmall "12px-XsmallAttach",
   Award-large "24px-LargeAward",
   Award-small "16px-SmallAward",
   Award-xsmall "12px-XsmallAward",
   Ban-large "24px-LargeBan",
   Ban-small "16px-SmallBan",
   Ban-xsmall "12px-XsmallBan",
   Bookmark-large "24px-LargeBookmark",
   Bookmark-small "16px-SmallBookmark",
   Bookmark-xsmall "12px-XsmallBookmark",
   Brush-large "24px-LargeBrush",
   Brush-small "16px-SmallBrush",
   Brush-xsmall "12px-XsmallBrush",
   Bubble-Chart-large "24px-LargeBubble-Chart",
   Bubble-Chart-small "16px-SmallBubble-Chart",
   Bubble-Chart-xsmall "12px-XsmallBubble-Chart",
   Buy-large "24px-LargeBuy",
   Buy-small "16px-SmallBuy",
   Buy-xsmall "12px-XsmallBuy",
   Calendar-large "24px-LargeCalendar",
   Calendar-small "16px-SmallCalendar",
   Calendar-xsmall "12px-XsmallCalendar",
   Call-out-large "24px-LargeCall-out",
   Call-out-small "16px-SmallCall-out",
   Call-out-xsmall "12px-XsmallCall-out",
   Camera-large "24px-LargeCamera",
   Camera-small "16px-SmallCamera",
   Camera-xsmall "12px-XsmallCamera",
   Card-View-large "24px-LargeCard-View",
   Card-view-small "16px-SmallCard-view",
   Card-view-xsmall "12px-XsmallCard-view",
   Categories-large "24px-LargeCategories",
   Categories-new-small "16px-SmallCategories-new",
   Categories-new-xsmall "12px-XsmallCategories-new",
   Categories-small "16px-SmallCategories",
   Categories-xsmall "12px-XsmallCategories",
   Category-new-large "24px-LargeCategory-new",
   Channels-large "24px-LargeChannels",
   Channels-small "16px-SmallChannels",
   Channels-xsmall "12px-XsmallChannels",
   ChartBar-large "24px-LargeChartBar",
   ChartBar-small "16px-SmallChartBar",
   ChartBar-xsmall "12px-XsmallChartBar",
   ChartLine-large "24px-LargeChartLine",
   ChartLine-small "16px-SmallChartLine",
   ChartLine-xsmall "12px-XsmallChartLine",
   ChartPie-large "24px-LargeChartPie",
   ChartPie-small "16px-SmallChartPie",
   ChartPie-xsmall "12px-XsmallChartPie",
   Chat-large "24px-LargeChat",
   Chat-small "16px-SmallChat",
   Chat-xsmall "12px-XsmallChat",
   Check-Large-large "24px-LargeCheck-Large",
   Check-Large-small "16px-SmallCheck-Large",
   Check-Large-xsmall "12px-XsmallCheck-Large",
   Check-large "24px-LargeCheck",
   Check-list-large "24px-LargeCheck-list",
   Check-list-small "16px-SmallCheck-list",
   Check-list-xsmall "12px-XsmallCheck-list",
   Check-small "16px-SmallCheck",
   Check-xsmall "12px-XsmallCheck",
   ChevronCollapse-large "24px-LargeChevronCollapse",
   ChevronCollapse-small "16px-SmallChevronCollapse",
   ChevronCollapse-xsmall "12px-XsmallChevronCollapse",
   ChevronExpand-large "24px-LargeChevronExpand",
   ChevronExpand-small "16px-SmallChevronExpand",
   ChevronExpand-xsmall "12px-XsmallChevronExpand",
   ChevronLeft-large "24px-LargeChevronLeft",
   ChevronLeft-small "16px-SmallChevronLeft",
   ChevronLeft-xsmall "12px-XsmallChevronLeft",
   ChevronRight-large "24px-LargeChevronRight",
   ChevronRight-small "16px-SmallChevronRight",
   ChevronRight-xsmall "12px-XsmallChevronRight",
   ChevronSmall-large "24px-LargeChevronSmall",
   ChevronSmall-small "16px-SmallChevronSmall",
   ChevronSmall-xsmall "12px-XsmallChevronSmall",
   Clock-large "24px-LargeClock",
   Clock-small "16px-SmallClock",
   Clock-xsmall "12px-XsmallClock",
   Close-large "24px-LargeClose",
   Close-small "16px-SmallClose",
   Close-small-small "16px-SmallClose-small",
   Close-small-xsmall "12px-XsmallClose-small",
   Close-xsmall "12px-XsmallClose",
   Cloud-Done-large "24px-LargeCloud-Done",
   Cloud-Done-small "16px-SmallCloud-Done",
   Cloud-Done-xsmall "12px-XsmallCloud-Done",
   Cloud-Off-large "24px-LargeCloud-Off",
   Cloud-Off-small "16px-SmallCloud-Off",
   Cloud-Off-xsmall "12px-XsmallCloud-Off",
   Code-large "24px-LargeCode",
   Code-small "16px-SmallCode",
   Code-xsmall "12px-XsmallCode",
   Collapse-large "24px-LargeCollapse",
   Collapse-small "16px-SmallCollapse",
   Collapse-xsmall "12px-XsmallCollapse",
   Color-large "24px-LargeColor",
   Color-small "16px-SmallColor",
   Color-xsmall "12px-XsmallColor",
   Colour-Picker-large "24px-LargeColour-Picker",
   Colour-Picker-small "16px-SmallColour-Picker",
   Colour-Picker-xsmall "12px-XsmallColour-Picker",
   Colour-reset-large "24px-LargeColour-reset",
   Colour-reset-small "16px-SmallColour-reset",
   Colour-reset-xsmall "12px-XsmallColour-reset",
   Comment-large "24px-LargeComment",
   Comment-small "16px-SmallComment",
   Comment-xsmall "12px-XsmallComment",
   Company-large "24px-LargeCompany",
   Company-small "16px-SmallCompany",
   Company-xsmall "12px-XsmallCompany",
   Conditional-large "24px-LargeConditional",
   Conditional-small "16px-SmallConditional",
   Conditional-xsmall "12px-XsmallConditional",
   Contact-large "24px-LargeContact",
   Contact-small "16px-SmallContact",
   Contact-xsmall "12px-XsmallContact",
   Create-large "24px-LargeCreate",
   Create-small "16px-SmallCreate",
   Create-xsmall "12px-XsmallCreate",
   Dash-large "24px-LargeDash",
   Dash-small "16px-SmallDash",
   Dash-xsmall "12px-XsmallDash",
   Delete-large "24px-LargeDelete",
   Delete-small "16px-SmallDelete",
   Delete-xsmall "12px-XsmallDelete",
   Depandancy-large "24px-LargeDepandancy",
   Depandancy-small "16px-SmallDepandancy",
   Depandancy-xsmall "12px-XsmallDepandancy",
   Document-copy-large "24px-LargeDocument-copy",
   Document-copy-small "16px-SmallDocument-copy",
   Document-copy-xsmall "12px-XsmallDocument-copy",
   Done-large "24px-LargeDone",
   Done-small "16px-SmallDone",
   Done-xsmall "12px-XsmallDone",
   Double-arrowLeft-large "24px-LargeDouble-arrowLeft",
   Double-arrowLeft-small "16px-SmallDouble-arrowLeft",
   Double-arrowLeft-xsmall "12px-XsmallDouble-arrowLeft",
   Double-arrowRight-large "24px-LargeDouble-arrowRight",
   Double-arrowRight-small "16px-SmallDouble-arrowRight",
   Double-arrowRight-xsmall "12px-XsmallDouble-arrowRight",
   Download-large "24px-LargeDownload",
   Download-small "16px-SmallDownload",
   Download-xsmall "12px-XsmallDownload",
   Drag-large "24px-LargeDrag",
   Drag-small "16px-SmallDrag",
   Drag-xsmall "12px-XsmallDrag",
   DragArrows-large "24px-LargeDragArrows",
   DragArrows-small "16px-SmallDragArrows",
   DragArrows-xsmall "12px-XsmallDragArrows",
   DropdownBg-large "24px-LargeDropdownBg",
   DropdownBg-small "16px-SmallDropdownBg",
   DropdownBg-xsmall "12px-XsmallDropdownBg",
   DropdownSm-large "24px-LargeDropdownSm",
   DropdownSm-small "16px-SmallDropdownSm",
   DropdownSm-xsmall "12px-XsmallDropdownSm",
   Edit-Columns-large "24px-LargeEdit-Columns",
   Edit-Columns-small "16px-SmallEdit-Columns",
   Edit-Columns-xsmall "12px-XsmallEdit-Columns",
   Edit-large "24px-LargeEdit",
   Edit-small "16px-SmallEdit",
   Edit-xsmall "12px-XsmallEdit",
   Emoji-large "24px-LargeEmoji",
   Emoji-small "16px-SmallEmoji",
   Emoji-xsmall "12px-XsmallEmoji",
   Enlarge-large "24px-LargeEnlarge",
   Enlarge-small "16px-SmallEnlarge",
   Enlarge-xsmall "12px-XsmallEnlarge",
   Evaluate-large "24px-LargeEvaluate",
   Evaluate-small "16px-SmallEvaluate",
   Evaluate-xsmall "12px-XsmallEvaluate",
   Evaluator-comment-large "24px-LargeEvaluator-comment",
   Evaluator-comment-small "16px-SmallEvaluator-comment",
   Evaluator-comment-xsmall "12px-XsmallEvaluator-comment",
   Exit-large "24px-LargeExit",
   Exit-small "16px-SmallExit",
   Exit-xsmall "12px-XsmallExit",
   Facebook-large "24px-LargeFacebook",
   Facebook-small "16px-SmallFacebook",
   Facebook-xsmall "12px-XsmallFacebook",
   File-Copies-large "24px-LargeFile-Copies",
   File-Copies-small "16px-SmallFile-Copies",
   File-Copies-xsmall "12px-XsmallFile-Copies",
   File-large "24px-LargeFile",
   File-small "16px-SmallFile",
   File-xsmall "12px-XsmallFile",
   Filter-large "24px-LargeFilter",
   Filter-small "16px-SmallFilter",
   Filter-xsmall "12px-XsmallFilter",
   Fit-Screen-large "24px-LargeFit-Screen",
   Fit-Screen-small "16px-SmallFit-Screen",
   Fit-Screen-xsmall "12px-XsmallFit-Screen",
   Fit-height-large "24px-LargeFit-height",
   Fit-height-small "16px-SmallFit-height",
   Fit-height-xsmall "12px-XsmallFit-height",
   Fit-width-large "24px-LargeFit-width",
   Fit-width-small "16px-SmallFit-width",
   Fit-width-xsmall "12px-XsmallFit-width",
   Flag-large "24px-LargeFlag",
   Flag-small "16px-SmallFlag",
   Flag-xsmall "12px-XsmallFlag",
   Form-large "24px-LargeForm",
   Form-small "16px-SmallForm",
   Form-xsmall "12px-XsmallForm",
   Funnel-large "24px-LargeFunnel",
   Funnel-small "16px-SmallFunnel",
   Funnel-xsmall "12px-XsmallFunnel",
   Google-large "24px-LargeGoogle",
   Google-small "16px-SmallGoogle",
   Google-xsmall "12px-XsmallGoogle",
   GraphCurve-large "24px-LargeGraphCurve",
   GraphCurve-small "16px-SmallGraphCurve",
   GraphCurve-xsmall "12px-XsmallGraphCurve",
   Grid-large "24px-LargeGrid",
   Grid-small "16px-SmallGrid",
   Grid-xsmall "12px-XsmallGrid",
   Grow-large "24px-LargeGrow",
   Grow-small "16px-SmallGrow",
   Grow-xsmall "12px-XsmallGrow",
   Hamburger-large "24px-LargeHamburger",
   Hamburger-small "16px-SmallHamburger",
   Hamburger-xsmall "12px-XsmallHamburger",
   Heading-1-large "24px-LargeHeading-1",
   Heading-1-small "16px-SmallHeading-1",
   Heading-1-xsmall "12px-XsmallHeading-1",
   Heading-2-large "24px-LargeHeading-2",
   Heading-2-small "16px-SmallHeading-2",
   Heading-2-xsmall "12px-XsmallHeading-2",
   Heading-3-large "24px-LargeHeading-3",
   Heading-3-small "16px-SmallHeading-3",
   Heading-3-xsmall "12px-XsmallHeading-3",
   Heading-4-large "24px-LargeHeading-4",
   Heading-4-small "16px-SmallHeading-4",
   Heading-4-xsmall "12px-XsmallHeading-4",
   Heading-5-large "24px-LargeHeading-5",
   Heading-5-small "16px-SmallHeading-5",
   Heading-5-xsmall "12px-XsmallHeading-5",
   Heading-6-large "24px-LargeHeading-6",
   Heading-6-small "16px-SmallHeading-6",
   Heading-6-xsmall "12px-XsmallHeading-6",
   Heart-large "24px-LargeHeart",
   Heart-small "16px-SmallHeart",
   Heart-xsmall "12px-XsmallHeart",
   Heatmap-large "24px-LargeHeatmap",
   Heatmap-small "16px-SmallHeatmap",
   Heatmap-xsmall "12px-XsmallHeatmap",
   Help-Center-large "24px-LargeHelp-Center",
   Help-Center-small "16px-SmallHelp-Center",
   Help-Center-xsmall "12px-XsmallHelp-Center",
   Hierarchy-large "24px-LargeHierarchy",
   Hierarchy-small "16px-SmallHierarchy",
   Hierarchy-xsmall "12px-XsmallHierarchy",
   Home-large "24px-LargeHome",
   Home-small "16px-SmallHome",
   Home-xsmall "12px-XsmallHome",
   Image-Align-Center-large "24px-LargeImage-Align-Center",
   Image-Align-Left-large "24px-LargeImage-Align-Left",
   Image-Align-Right-large "24px-LargeImage-Align-Right",
   Image-Caption-large "24px-LargeImage-Caption",
   Image-Caption-small "16px-SmallImage-Caption",
   Image-Caption-xsmall "12px-XsmallImage-Caption",
   Image-Center-small "16px-SmallImage-Center",
   Image-Center-xsmall "12px-XsmallImage-Center",
   Image-Left-small "16px-SmallImage-Left",
   Image-Left-xsmall "12px-XsmallImage-Left",
   Image-Right-small "16px-SmallImage-Right",
   Image-Right-xsmall "12px-XsmallImage-Right",
   Image-large "24px-LargeImage",
   Image-small "16px-SmallImage",
   Image-xsmall "12px-XsmallImage",
   Improve-writing-large "24px-LargeImprove-writing",
   Improve-writing-small "16px-SmallImprove-writing",
   Improve-writing-xsmall "12px-XsmallImprove-writing",
   Inbox-large "24px-LargeInbox",
   Inbox-small "16px-SmallInbox",
   Inbox-xsmall "12px-XsmallInbox",
   Infinite-loop-large "24px-LargeInfinite-loop",
   Infinite-loop-small "16px-SmallInfinite-loop",
   Infinite-loop-xsmall "12px-XsmallInfinite-loop",
   Info-large "24px-LargeInfo",
   Info-small "16px-SmallInfo",
   Info-xsmall "12px-XsmallInfo",
   Job-large "24px-LargeJob",
   Job-small "16px-SmallJob",
   Job-xsmall "12px-XsmallJob",
   Kanban-large "24px-LargeKanban",
   Kanban-small "16px-SmallKanban",
   Kanban-xsmall "12px-XsmallKanban",
   Key-large "24px-LargeKey",
   Key-small "16px-SmallKey",
   Key-xsmall "12px-XsmallKey",
   Lightbulb-large "24px-LargeLightbulb",
   Lightbulb-small "16px-SmallLightbulb",
   Lightbulb-xsmall "12px-XsmallLightbulb",
   Like-large "24px-LargeLike",
   Like-small "16px-SmallLike",
   Like-xsmall "12px-XsmallLike",
   Linear-Scale-large "24px-LargeLinear-Scale",
   Linear-Scale-small "16px-SmallLinear-Scale",
   Linear-Scale-xsmall "12px-XsmallLinear-Scale",
   Link-large "24px-LargeLink",
   Link-small "16px-SmallLink",
   Link-xsmall "12px-XsmallLink",
   LinkedIn-large "24px-LargeLinkedIn",
   LinkedIn-small "16px-SmallLinkedIn",
   LinkedIn-xsmall "12px-XsmallLinkedIn",
   List-view-large "24px-LargeList-view",
   List-view-small "16px-SmallList-view",
   List-view-xsmall "12px-XsmallList-view",
   ListBullets-large "24px-LargeListBullets",
   ListBullets-small "16px-SmallListBullets",
   ListBullets-xsmall "12px-XsmallListBullets",
   ListNumbered-large "24px-LargeListNumbered",
   ListNumbered-small "16px-SmallListNumbered",
   ListNumbered-xsmall "12px-XsmallListNumbered",
   Loading-large "24px-LargeLoading",
   Loading-small "16px-SmallLoading",
   Loading-xsmall "12px-XsmallLoading",
   Location-large "24px-LargeLocation",
   Location-small "16px-SmallLocation",
   Location-xsmall "12px-XsmallLocation",
   LockLocked-large "24px-LargeLockLocked",
   LockLocked-small "16px-SmallLockLocked",
   LockLocked-xsmall "12px-XsmallLockLocked",
   LockUnlocked-large "24px-LargeLockUnlocked",
   LockUnlocked-small "16px-SmallLockUnlocked",
   LockUnlocked-xsmall "12px-XsmallLockUnlocked",
   Messages-large "24px-LargeMessages",
   Messages-small "16px-SmallMessages",
   Messages-xsmall "12px-XsmallMessages",
   Minus-large "24px-LargeMinus",
   Minus-small "16px-SmallMinus",
   Minus-xsmall "12px-XsmallMinus",
   More-large "24px-LargeMore",
   More-small "16px-SmallMore",
   More-xsmall "12px-XsmallMore",
   Move-down-large "24px-LargeMove-down",
   Move-down-small "16px-SmallMove-down",
   Move-down-xsmall "12px-XsmallMove-down",
   Network-connection-large "24px-LargeNetwork-connection",
   Network-connection-small "16px-SmallNetwork-connection",
   Network-connection-xsmall "12px-XsmallNetwork-connection",
   Note-large "24px-LargeNote",
   Note-small "16px-SmallNote",
   Note-xsmall "12px-XsmallNote",
   Notifications-Off-large "24px-LargeNotifications-Off",
   Notifications-Off-small "16px-SmallNotifications-Off",
   Notifications-Off-xsmall "12px-XsmallNotifications-Off",
   Notifications-On-large "24px-LargeNotifications-On",
   Notifications-On-small "16px-SmallNotifications-On",
   Notifications-On-xsmall "12px-XsmallNotifications-On",
   Number-large "24px-LargeNumber",
   Number-small "16px-SmallNumber",
   Number-xsmall "12px-XsmallNumber",
   Open-in-full-large "24px-LargeOpen-in-full",
   Open-in-full-small "16px-SmallOpen-in-full",
   Open-in-full-xsmall "12px-XsmallOpen-in-full",
   Open-large "24px-LargeOpen",
   Open-small "16px-SmallOpen",
   Open-xsmall "12px-XsmallOpen",
   Order-large "24px-LargeOrder",
   Order-small "16px-SmallOrder",
   Order-xsmall "12px-XsmallOrder",
   Pin-large "24px-LargePin",
   Pin-small "16px-SmallPin",
   Pin-xsmall "12px-XsmallPin",
   Platform-large "24px-LargePlatform",
   Platform-small "16px-SmallPlatform",
   Platform-xsmall "12px-XsmallPlatform",
   Play-large "24px-LargePlay",
   Play-small "16px-SmallPlay",
   Play-xsmall "12px-XsmallPlay",
   Plus-large "24px-LargePlus",
   Plus-small "16px-SmallPlus",
   Plus-xsmall "12px-XsmallPlus",
   Post-large "24px-LargePost",
   Post-small "16px-SmallPost",
   Post-xsmall "12px-XsmallPost",
   Preference-large "24px-LargePreference",
   Preference-small "16px-SmallPreference",
   Preference-xsmall "12px-XsmallPreference",
   Print-large "24px-LargePrint",
   Print-small "16px-SmallPrint",
   Print-xsmall "12px-XsmallPrint",
   Question-large "24px-LargeQuestion",
   Question-small "16px-SmallQuestion",
   Question-xsmall "12px-XsmallQuestion",
   Redo-large "24px-LargeRedo",
   Redo-small "16px-SmallRedo",
   Redo-xsmall "12px-XsmallRedo",
   Refresh-large "24px-LargeRefresh",
   Refresh-small "16px-SmallRefresh",
   Refresh-xsmall "12px-XsmallRefresh",
   Remove-large "24px-LargeRemove",
   Remove-small "16px-SmallRemove",
   Remove-xsmall "12px-XsmallRemove",
   RemoveMinus-large "24px-LargeRemoveMinus",
   RemoveMinus-small "16px-SmallRemoveMinus",
   RemoveMinus-xsmall "12px-XsmallRemoveMinus",
   Reply-large "24px-LargeReply",
   Reply-small "16px-SmallReply",
   Reply-xsmall "12px-XsmallReply",
   Resize-large "24px-LargeResize",
   Resize-small "16px-SmallResize",
   Resize-xsmall "12px-XsmallResize",
   Return-large "24px-LargeReturn",
   Return-small "16px-SmallReturn",
   Return-xsmall "12px-XsmallReturn",
   Search-large "24px-LargeSearch",
   Search-small "16px-SmallSearch",
   Search-xsmall "12px-XsmallSearch",
   Semantic-Error-large "24px-LargeSemantic-Error",
   Semantic-Error-small "16px-SmallSemantic-Error",
   Semantic-Error-xsmall "12px-XsmallSemantic-Error",
   Semantic-Help-large "24px-LargeSemantic-Help",
   Semantic-Help-small "16px-SmallSemantic-Help",
   Semantic-Help-xsmall "12px-XsmallSemantic-Help",
   Semantic-Warning-large "24px-LargeSemantic-Warning",
   Semantic-Warning-small "16px-SmallSemantic-Warning",
   Semantic-Warning-xsmall "12px-XsmallSemantic-Warning",
   Send-large "24px-LargeSend",
   Send-small "16px-SmallSend",
   Send-xsmall "12px-XsmallSend",
   Settings-large "24px-LargeSettings",
   Settings-small "16px-SmallSettings",
   Settings-xsmall "12px-XsmallSettings",
   Share-large "24px-LargeShare",
   Share-small "16px-SmallShare",
   Share-xsmall "12px-XsmallShare",
   Short-text-large "24px-LargeShort-text",
   Short-text-small "16px-SmallShort-text",
   Short-text-xsmall "12px-XsmallShort-text",
   Shortcut-large "24px-LargeShortcut",
   Shortcut-small "16px-SmallShortcut",
   Shortcut-xsmall "12px-XsmallShortcut",
   Slider-large "24px-LargeSlider",
   Slider-small "16px-SmallSlider",
   Slider-xsmall "12px-XsmallSlider",
   Sort-Asc-small "16px-SmallSort-Asc",
   Sort-Desc-small "16px-SmallSort-Desc",
   Sort-large "24px-LargeSort",
   Sort-small "16px-SmallSort",
   Sort-xsmall "12px-XsmallSort",
   Stage-large "24px-LargeStage",
   Stage-small "16px-SmallStage",
   Stage-xsmall "12px-XsmallStage",
   Star-large "24px-LargeStar",
   Star-small "16px-SmallStar",
   Star-xsmall "12px-XsmallStar",
   Steppers-large "24px-LargeSteppers",
   Steppers-small "16px-SmallSteppers",
   Steppers-xsmall "12px-XsmallSteppers",
   Submission-Form-large "24px-LargeSubmission-Form",
   Submission-Form-small "16px-SmallSubmission-Form",
   Submission-Form-xsmall "12px-XsmallSubmission-Form",
   Switch-large "24px-LargeSwitch",
   Switch-on-large "24px-LargeSwitch-on",
   Switch-on-small "16px-SmallSwitch-on",
   Switch-on-xsmall "12px-XsmallSwitch-on",
   Switch-small "16px-SmallSwitch",
   Switch-xsmall "12px-XsmallSwitch",
   Table-Chart-large "24px-LargeTable-Chart",
   Table-Chart-small "16px-SmallTable-Chart",
   Table-Chart-xsmall "12px-XsmallTable-Chart",
   Table-large "24px-LargeTable",
   Table-small "16px-SmallTable",
   Table-xsmall "12px-XsmallTable",
   Tags-large "24px-LargeTags",
   Tags-small "16px-SmallTags",
   Tags-xsmall "12px-XsmallTags",
   Target-large "24px-LargeTarget",
   Target-small "16px-SmallTarget",
   Target-xsmall "12px-XsmallTarget",
   Team-large "24px-LargeTeam",
   Team-small "16px-SmallTeam",
   Team-xsmall "12px-XsmallTeam",
   Text-StyleBold-large "24px-LargeText-StyleBold",
   Text-StyleBold-small "16px-SmallText-StyleBold",
   Text-StyleBold-xsmall "12px-XsmallText-StyleBold",
   Text-StyleItalic-large "24px-LargeText-StyleItalic",
   Text-StyleItalic-small "16px-SmallText-StyleItalic",
   Text-StyleItalic-xsmall "12px-XsmallText-StyleItalic",
   Text-StyleUnderline-large "24px-LargeText-StyleUnderline",
   Text-StyleUnderline-small "16px-SmallText-StyleUnderline",
   Text-StyleUnderline-xsmall "12px-XsmallText-StyleUnderline",
   Text-size-large "24px-LargeText-size",
   Text-size-small "16px-SmallText-size",
   Text-size-xsmall "12px-XsmallText-size",
   Tie-large "24px-LargeTie",
   Tie-small "16px-SmallTie",
   Tie-xsmall "12px-XsmallTie",
   Timeline-large "24px-LargeTimeline",
   Timeline-small "16px-SmallTimeline",
   Timeline-xsmall "12px-XsmallTimeline",
   Title-large "24px-LargeTitle",
   Title-small "16px-SmallTitle",
   Title-xsmall "12px-XsmallTitle",
   Translation-large "24px-LargeTranslation",
   Translation-small "16px-SmallTranslation",
   Translation-xsmall "12px-XsmallTranslation",
   Trophy-large "24px-LargeTrophy",
   Trophy-small "16px-SmallTrophy",
   Trophy-xsmall "12px-XsmallTrophy",
   URL-large "24px-LargeURL",
   URL-small "16px-SmallURL",
   URL-xsmall "12px-XsmallURL",
   Undo-large "24px-LargeUndo",
   Undo-small "16px-SmallUndo",
   Undo-xsmall "12px-XsmallUndo",
   Undo2-large "24px-LargeUndo2",
   Undo2-small "16px-SmallUndo2",
   Undo2-xsmall "12px-XsmallUndo2",
   Unlink-large "24px-LargeUnlink",
   Unlink-small "16px-SmallUnlink",
   Unlink-xsmall "12px-XsmallUnlink",
   Update-large "24px-LargeUpdate",
   Update-small "16px-SmallUpdate",
   Update-xsmall "12px-XsmallUpdate",
   Upload-large "24px-LargeUpload",
   Upload-small "16px-SmallUpload",
   Upload-xsmall "12px-XsmallUpload",
   User-Badge-large "24px-LargeUser-Badge",
   User-Badge-small "16px-SmallUser-Badge",
   User-Badge-xsmall "12px-XsmallUser-Badge",
   User-Label-large "24px-LargeUser-Label",
   User-Label-small "16px-SmallUser-Label",
   User-Label-xsmall "12px-XsmallUser-Label",
   User-profile-large "24px-LargeUser-profile",
   UserMultiple-large "24px-LargeUserMultiple",
   UserMultiple-small "16px-SmallUserMultiple",
   UserMultiple-xsmall "12px-XsmallUserMultiple",
   UserSingle-large "24px-LargeUserSingle",
   UserSingle-small "16px-SmallUserSingle",
   UserSingle-xsmall "12px-XsmallUserSingle",
   Video-large "24px-LargeVideo",
   Video-small "16px-SmallVideo",
   Video-xsmall "12px-XsmallVideo",
   ViewHide-large "24px-LargeViewHide",
   ViewHide-small "16px-SmallViewHide",
   ViewHide-xsmall "12px-XsmallViewHide",
   ViewShow-large "24px-LargeViewShow",
   ViewShow-small "16px-SmallViewShow",
   ViewShow-xsmall "12px-XsmallViewShow",
   Wrap-text-large "24px-LargeWrap-text",
   Wrap-text-small "16px-SmallWrap-text",
   Wrap-text-xsmall "12px-XsmallWrap-text",
   Zoom-in-large "24px-LargeZoom-in",
   Zoom-in-small "16px-SmallZoom-in",
   Zoom-in-xsmall "12px-XsmallZoom-in",
   Zoom-out-large "24px-LargeZoom-out",
   Zoom-out-small "16px-SmallZoom-out",
   Zoom-out-xsmall "12px-XsmallZoom-out",
   upload-cloud-large "24px-Largeupload-cloud",
   upload-cloud-small "16px-Smallupload-cloud",
   upload-cloud-xsmall "12px-Xsmallupload-cloud"})
